export class LegalEntity {
    id: string;
    companyId: string;
    name: string;
    code: string;
    countryOfEstablishment: string;
    systemCode: string;
}